export const ROLE_GROUP_NAMES = {
  "Juniper Square Managed Close": "Managed Close - IC",
  "Juniper Square Managed Close Manager": "Managed Close - Manager",
  "Juniper Square Capital Events": "Capital Events - IC",
  "Juniper Square Capital Events Manager": "Capital Events - Manager",
  "Juniper Square Fund Accounting": "FAcct - IC",
  "Juniper Square Fund Accounting Manager": "FAcct - Manager",
  "Juniper Square Investor Services": "Core IS - IC",
  "Juniper Square Investor Services Manager": "Core IS - Manager",
  "Juniper Square Onboarding": "FAO - IC",
  "Juniper Square Onboarding Manager": "FAO - Manager",
  "Juniper Square Operations Manager": "FA Ops - admin",
} as const;

export type WorkspaceRoleGroupNames = keyof typeof ROLE_GROUP_NAMES;

// These roles have the ability to manage positions in JSQ administered entities
export const ROLES_WITH_POSITIONS_MANAGE_PERMISSION: WorkspaceRoleGroupNames[] = [
  "Juniper Square Investor Services",
  "Juniper Square Investor Services Manager",
  "Juniper Square Onboarding",
  "Juniper Square Onboarding Manager",
  "Juniper Square Operations Manager",
];
